import { WorkingTimePeriodDto } from 'src/app/models/dtos/absences/working-time-periods-dto';

/** 'YYYY-MM-DD' key of a date already expressed in local (Europe/Warsaw) time. */
export const toDateKey = (value: Date | string): string => {
  if (typeof value === 'string') {
    return value.substring(0, 10);
  }

  const month = `${value.getMonth() + 1}`.padStart(2, '0');
  const day = `${value.getDate()}`.padStart(2, '0');
  return `${value.getFullYear()}-${month}-${day}`;
};

export const periodContains = (period: WorkingTimePeriodDto, dateKey: string): boolean =>
  toDateKey(period.StartDate) <= dateKey && (period.EndDate == null || toDateKey(period.EndDate) >= dateKey);

export const findPeriod = (periods: WorkingTimePeriodDto[], value: Date | string): WorkingTimePeriodDto | null => {
  const dateKey = toDateKey(value);
  return periods.find((period) => periodContains(period, dateKey)) ?? null;
};

/** Both endpoints and the entire ordered range must belong to one effective segment. */
export const periodContainsRange = (period: WorkingTimePeriodDto, start: Date | string, end: Date | string): boolean =>
  toDateKey(start) <= toDateKey(end) && periodContains(period, toDateKey(start)) && periodContains(period, toDateKey(end));

/** Valid part-time fraction (0 < N < D); full time and missing/invalid data are not scaled. */
export const isPartTimePeriod = (period: WorkingTimePeriodDto | null): period is WorkingTimePeriodDto & { Nominator: number; Denominator: number } =>
  !!period &&
  period.Nominator != null &&
  period.Denominator != null &&
  period.Nominator > 0 &&
  period.Nominator < period.Denominator;
